import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {}

const state = {
  info: startState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.info = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.info = startState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.info
}

export const Info = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/pageInfo/Info.js